import { render, staticRenderFns } from "./header-top.vue?vue&type=template&id=070265c2&scoped=true"
import script from "./header-top.vue?vue&type=script&lang=js"
export * from "./header-top.vue?vue&type=script&lang=js"
import style0 from "./header-top.vue?vue&type=style&index=0&id=070265c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070265c2",
  null
  
)

export default component.exports